// $app-layout-main-z-index:
let popperZIndex = 12

const nextBelowZIndex = () => {
  return popperZIndex++
}

export default nextBelowZIndex
